// extracted by mini-css-extract-plugin
module.exports = {"ciy07fq":"ciy07fq","clas2p":"clas2p"};